import { createContext } from "react";

import { ClaimsContextType } from "./ClaimsContext.types";

export const ClaimsContext = createContext<ClaimsContextType | undefined>(undefined);
